<template>
  <section class="hd-wap-help">
    <div class="list">
      <div class="item">
        <h1 class="f13">1.无法登录怎么办？</h1>
        <div class="content">
          <p class="f12">(1) 退出APP，关闭所有进程，再重新登录</p>
          <p class="f12">(2) 卸载当前APP，安装最新版本</p>
        </div>
      </div>
      <div class="item">
        <h1 class="f13">2.找不到之前的学习记录怎么办？</h1>
        <div class="content">
          <p class="f12">当前登录帐号不是购课时的帐号：例如购课时是手机验证码登录的，但查看时用第三方授权登录。建议固定登录方式后，无特殊情况，不要随意变更。</p>
        </div>
      </div>
      <div class="item">
        <h1 class="f13">3.错过免费直播怎么办？</h1>
        <div class="content">
          <p class="f12">如无法观看免费直播，可以在直播历史栏目中支付积分后查看对应录播，需要在课程有效期前，有效期后录播自动下架，无法恢复，请您谅解。</p>
        </div>
      </div>
      <div class="item">
        <h1 class="f13">4.课程视频无法打开怎么办？</h1>
        <div class="content">
          <p class="f12">抱歉给您带来麻烦，建议卸载，安装最新版本，在网络良好的情况下重新登录打开对应课程视频。</p>
        </div>
      </div>
      <div class="item">
        <h1 class="f13">5.ios设备，没法连接网络，怎么解决？</h1>
        <div class="content">
          <p class="f12">从设置-无线局域网-使用无线局域网与蜂窝移动的应用-找到“海渡职校”，开启无线局域网与蜂窝移动。</p>
        </div>
      </div>
      <div class="item">
        <h1 class="f13">6.有开发pc或mac版本计划么？</h1>
        <div class="content">
          <p class="f12">pc版官网地址为：<a href="http://www.edubotcoll.com">www.edubotcoll.com</a> ，即将上线更多功能，谢谢关注和支持。</p>
        </div>
      </div>
      <div class="item">
        <h1 class="f13">7.有职校讲师招募计划么？</h1>
        <div class="content">
          <p class="f12">海渡职校欢迎社会各界关注工业机器人教育的小伙伴加入共建计划，入驻讲师及机构会获得对应订阅学员的学费回馈，详情欢迎登陆职校官网<a href="http://www.edubotcoll.com">www.edubotcoll.com</a>查看。</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: '',
  data() {
    return {

    }
  },
  created() {

  },
  computed: {

  },
  methods: {

  }
}

</script>
<style lang="scss" scoped>
.hd-wap-help {
  padding: 0.533rem 0.267rem;
  .list {
    width: 100%;
    .item {
      margin-top: 0.707rem;
      &:first-child {
        margin-top: 0;
      }
      h1 {
        color: #333333;
      }
      .content {
        color: #333333;
        line-height: 1.5;
        margin-top: 0.133rem;
        a {
          color: #0193e6;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Help.vue?56465d6a